<template>
  <div class="catalog-page">
   


    <!-- MAIN LAYOUT -->
    <section class="catalog-content">
      

      <!-- ITEMS PANEL -->
      <div class="catalog-items">
        <div class="panel">
          <!-- ITEMS HEADER -->
          <div class="panel-header items-header">
            

            <button
              class="btn btn-text"
              @click="refresh"
              :disabled="loading"
              aria-label="Rafraîchir les articles"
            >
              <i
                :class="
                  loading ? 'bi bi-arrow-repeat spin' : 'bi bi-arrow-repeat'
                "
              ></i>
              Rafraîchir
            </button>
          </div>

          <!-- ITEMS BODY -->
          <div class="panel-body items-body">
            <!-- ITEMS TOOLBAR -->
            <div class="items-toolbar">
              <div class="search-field">
                <i class="bi bi-search"></i>
                <input
                  v-model.trim="searchTerm"
                  type="search"
                  placeholder="Rechercher un produit, une référence..."
                  aria-label="Rechercher un produit"
                />
                <button
                  v-if="searchTerm"
                  class="btn-clear"
                  type="button"
                  @click="clearSearch"
                  aria-label="Effacer la recherche"
                >
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>

             
            </div>

            


            <!-- ITEMS GRID -->
            <div class="items-container">
              <!-- LOADING SKELETON -->
              <div v-if="loading" class="items-grid">
                <div v-for="i in 12" :key="i" class="item-card skeleton">
                  <div class="item-image-container shimmer"></div>
                  <div class="item-info">
                    <div class="line shimmer"></div>
                    <div class="line short shimmer"></div>
                  </div>
                </div>
              </div>

              <div v-else-if="visibleProducts.length" class="items-grid">
                <div
                  class="item-card"
                  v-for="product in visibleProducts"
                  :key="product.reference"
                  @click="openQuantityModal(product)"
                  @keyup.enter="openQuantityModal(product)"
                  tabindex="0"
                  role="button"
                  :aria-label="`Ajouter quantité pour ${product.fullName}`"
                >
                  <div class="item-image-container">
                    <img
                      :src="$imageUrl(product.image)"
                      class="item-image"
                      :alt="product.fullName"
                      @error="imageFallback"
                      loading="lazy"
                      decoding="async"
                    />
                    <!-- <div
                      class="stock-badge"
                      :class="{
                        ok: (product.quantity || 0) > 10,
                        low:
                          (product.quantity || 0) > 0 &&
                          (product.quantity || 0) <= 10,
                        out: (product.quantity || 0) <= 0,
                      }"
                      aria-hidden="true"
                    >
                      {{ formatQuantity(product.quantity || 0) }} KG
                    </div> -->
                  </div>

                  <div class="item-info">
                    <h4 class="item-name" :title="product.fullName">
                      {{ product.fullName }}
                    </h4>
                    <div class="item-meta">
                      <span class="cat" v-if="product.category?.fullName">{{
                        product.category.fullName
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="items-empty-state">
                <div class="empty-icon">
                  <i class="bi bi-basket"></i>
                </div>
                <h3>Aucun article trouvé</h3>
                <p>
                  Ajustez votre recherche ou sélectionnez une autre catégorie
                  pour découvrir davantage de produits.
                </p>
                <button class="btn btn-outline-light" @click="resetFilters">
                  Réinitialiser filtres
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- QUANTITY MODAL -->
    <transition name="fade">
      <div v-if="showModal" class="modal-overlay" @click="closeModal">
        <div
          class="modal-content"
          @click.stop
          role="dialog"
          aria-modal="true"
          aria-label="Entrer la quantité"
        >
          <div class="modal-header">
            <h3 class="modal-title">Entrer la quantité</h3>
            <button
              class="btn btn-close"
              @click="closeModal"
              aria-label="Fermer"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body">
            <div class="selected-product">
              <img
                v-if="selectedProduct"
                :src="$imageUrl(selectedProduct.image)"
                class="product-image-modal"
                @error="imageFallback"
                alt=""
              />
              <h4 class="product-name-modal">
                {{ selectedProduct?.fullName }}
              </h4>
            </div>

            <div class="quantity-input-section">
              <div class="quantity-display">
                <span class="quantity-label">Quantité (KG):</span>
                <span class="quantity-value">{{ quantityValue || "0" }}</span>
              </div>

              <!-- KEYBOARD -->
              <div class="modal-keyboard" @keydown.stop>
                <div class="keyboard-grid">
                  <button
                    v-for="n in keys"
                    :key="n"
                    class="btn btn-key"
                    :class="{ 'btn-key-clear': n === 'C' }"
                    @click="keyboardPress(n)"
                  >
                    {{ n }}
                  </button>
                </div>
                <input
                  ref="hiddenQty"
                  class="sr-only"
                  type="text"
                  inputmode="decimal"
                  @keydown.stop.prevent="handlePhysicalKey($event)"
                  aria-hidden="true"
                />
              </div>
            </div>

            <div v-if="!customer" class="customer-warning">
              <i class="bi bi-exclamation-triangle"></i>
              Sélectionnez un client d'abord
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" @click="closeModal">
              <i class="bi bi-x-circle"></i> Annuler
            </button>

            <button
              class="btn btn-success"
              @click="confirmAddToCart"
              :disabled="!customer || !quantityValue"
            >
              <i class="bi bi-check-circle"></i> Ajouter
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CatalogPage",
  data() {
    return {
      loading: false,
      activeCategory: "all",
      sectionSearch: "",
      showModal: false,
      selectedProduct: null,
      quantityValue: "",
      searchTerm: "",
      showOnlyAvailable: false,
      showOnlyLowStock: false,
      keys: ["7", "8", "9", "0", "4", "5", "6", "C", "1", "2", "3", "."],
    };
  },

  computed: {
    ...mapGetters("product", { productsRaw: "getAll" }),
    ...mapGetters("category", { categoriesRaw: "getAll" }),
    ...mapGetters("customer", { customer: "getCustomer" }),

    productList() {
      return Array.isArray(this.productsRaw?.data)
        ? this.productsRaw.data
        : this.productsRaw || [];
    },

    categoryList() {
      return Array.isArray(this.categoriesRaw?.data)
        ? this.categoriesRaw.data
        : this.categoriesRaw || [];
    },

    filteredSections() {
      const q = this.sectionSearch.toLowerCase();
      return this.categoryList.filter((c) =>
        !q ? true : (c.fullName || "").toLowerCase().includes(q)
      );
    },

    featuredCategories() {
      return this.categoryList.slice(0, 10);
    },

    totalSections() {
      return this.categoryList.length;
    },

    totalProducts() {
      return this.productList.length;
    },

    totalQuantity() {
      return this.productList.reduce(
        (sum, p) => sum + Number(p.quantity || 0),
        0
      );
    },

    visibleProducts() {
      const search = this.searchTerm.toLowerCase();
      return this.productList
        .filter((product) => {
          if (this.activeCategory !== "all") {
            return (
              product.category_reference === this.activeCategory ||
              product.category?.reference === this.activeCategory
            );
          }
          return true;
        })
        .filter((product) => {
          if (!search) return true;
          const label = `${product.fullName || ""} ${product.reference || ""}`;
          return label.toLowerCase().includes(search);
        })
        .filter((product) => {
          const quantity = Number(product.quantity || 0);
          if (this.showOnlyAvailable && quantity <= 0) return false;
          if (this.showOnlyLowStock && quantity > 10) return false;
          return true;
        });
    },

    visibleQuantity() {
      return this.visibleProducts.reduce(
        (sum, p) => sum + Number(p.quantity || 0),
        0
      );
    },

    lastUpdatedLabel() {
      const timestamps = this.productList
        .map((p) => p.updated_at || p.created_at)
        .filter(Boolean)
        .map((x) => new Date(x).getTime());
      if (!timestamps.length) return "—";
      return new Date(Math.max(...timestamps)).toLocaleDateString();
    },
  },

  mounted() {
    this.refresh();
    this.$store.dispatch("customer/getAll");
  },

  methods: {
    async refresh() {
      try {
        this.loading = true;
        await this.$store.dispatch("product/getAll");
        await this.$store.dispatch("category/getAll");
      } finally {
        this.loading = false;
      }
    },

    goToStocks() {
      this.$router.push({ name: "stocks" });
    },

    setCategory(category) {
      if (!category) {
        this.activeCategory = "all";
        return;
      }
      this.activeCategory = category.reference;
      // Précharger items de la catégorie si nécessaire
      this.$store.dispatch("category/getItems", category.reference);
    },

    countItems(categoryRef) {
      return this.productList.filter(
        (p) =>
          p.category_reference === categoryRef ||
          p.category?.reference === categoryRef
      ).length;
    },

    /* Image fallback */
    imageFallback(e) {
      e.target.src =
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='320' height='200'%3E%3Crect width='100%25' height='100%25' fill='%23f1f5f9'/%3E%3Ctext x='50%25' y='50%25' fill='%2399a3af' font-size='14' text-anchor='middle' alignment-baseline='middle'%3ENo Image%3C/text%3E%3C/svg%3E";
    },

    /* --- MODAL --- */
    openQuantityModal(product) {
      this.selectedProduct = product;
      this.quantityValue = "";
      this.showModal = true;
      this.$nextTick(() => {
        // Focus invisible input to allow physical keyboard typing
        this.$refs.hiddenQty && this.$refs.hiddenQty.focus();
      });
    },

    closeModal() {
      this.showModal = false;
      this.selectedProduct = null;
      this.quantityValue = "";
    },

    /* --- KEYBOARD HANDLING --- */
    keyboardPress(key) {
      if (key === "C") {
        this.quantityValue = "";
        return;
      }
      if (key === ".") {
        if (!this.quantityValue) {
          this.quantityValue = "0.";
          return;
        }
        if (this.quantityValue.includes(".")) return;
      }
      this.quantityValue += key;
    },

    handlePhysicalKey(e) {
      const k = e.key;
      if (/^[0-9]$/.test(k)) {
        this.quantityValue += k;
      } else if (k === "." || k === ",") {
        if (!this.quantityValue.includes(".")) {
          this.quantityValue += this.quantityValue ? "." : "0.";
        }
      } else if (k === "Backspace") {
        this.quantityValue = this.quantityValue.slice(0, -1);
      } else if (k === "Escape") {
        this.closeModal();
      } else if (k === "Enter") {
        this.confirmAddToCart();
      }
    },

    async confirmAddToCart() {
      if (!this.customer || !this.quantityValue) return;
      await this.$store.dispatch("sale/storeItem", {
        quantity: this.quantityValue,
        customer_reference: this.customer.reference,
        item_reference: this.selectedProduct.reference,
        priceTTC: 0,
        priceHT: 0,
      });
      await this.$store.dispatch("cart/getItems");
      this.closeModal();
    },

    clearSearch() {
      this.searchTerm = "";
    },

    resetFilters() {
      this.searchTerm = "";
      this.activeCategory = "all";
      this.showOnlyAvailable = false;
      this.showOnlyLowStock = false;
      this.sectionSearch = "";
    },

    toggleAvailability() {
      this.showOnlyAvailable = !this.showOnlyAvailable;
      if (this.showOnlyAvailable) this.showOnlyLowStock = false;
    },

    toggleLowStock() {
      this.showOnlyLowStock = !this.showOnlyLowStock;
      if (this.showOnlyLowStock) this.showOnlyAvailable = false;
    },

    formatQuantity(value) {
      const qty = Number(value || 0);
      if (Number.isNaN(qty)) return "0";
      return qty.toLocaleString("fr-FR", {
        minimumFractionDigits: qty % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
/* Base tokens */
:root {
  --bg: #f7f8fb;
  --bg2: #eef1f8;
  --panel: #ffffff;
  --muted: #6b7280;
  --border: rgba(148, 163, 184, 0.25);
  --primary: #4f46e5;
  --primary-weak: rgba(79, 70, 229, 0.1);
  --success: #16a34a;
  --danger: #ef4444;
  --warning: #f59e0b;
}

/* Layout */
.catalog-page {
  height: 100vh;
  padding: 2rem 2rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background: linear-gradient(180deg, var(--bg) 0%, var(--bg2) 100%);
  overflow: hidden;
}

.catalog-page-header {
  display: flex;
  justify-content: space-between;
  gap: 1.25rem;
  flex-wrap: wrap;
  align-items: center;
}

.title-wrap h1 {
  font-size: 2.25rem;
  font-weight: 800;
  margin: 0 0 0.25rem 0;
}
.subtitle {
  margin: 0;
  color: var(--muted);
}

.header-actions {
  display: flex;
  gap: 0.6rem;
}

/* Summary cards */
.catalog-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 1.1rem;
}
.summary-card {
  background: var(--panel);
  padding: 1.1rem 1.25rem;
  border-radius: 20px;
  border: 1px solid var(--border);
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.07);
}
.summary-card span {
  color: var(--muted);
}
.summary-card strong {
  display: block;
  font-size: 1.35rem;
  margin-top: 0.25rem;
}

/* Content */
.catalog-content {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 1.5rem;
  flex: 1;
  min-height: 0;
}

/* Panels */
.panel {
  background: var(--panel);
  border-radius: 24px;
  box-shadow: 0 24px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
}
.panel-sticky {
  position: sticky;
  top: 1rem;
  max-height: calc(100vh - 7rem);
}
.panel-header {
  padding: 1.25rem 1.25rem 1rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}
.panel-header h2 {
  margin: 0 0 0.25rem 0;
  font-size: 1.15rem;
}
.panel-body {
  padding: 1rem 1.25rem 1.25rem;
}

/* Sidebar */
.sidebar-body {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.sidebar-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 999px;
  padding: 0.5rem 0.85rem;
}
.sidebar-search input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
}
.section-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
}
.section-chip {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  justify-content: space-between;
  padding: 0.6rem 0.85rem;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: #f8fafc;
  cursor: pointer;
  transition: 0.15s ease;
}
.section-chip .truncate {
  max-width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section-chip .badge {
  background: var(--primary-weak);
  color: var(--primary);
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
}
.section-chip:hover {
  background: #f1f5f9;
  transform: translateY(-1px);
}
.section-chip.active {
  background: var(--primary);
  color: #fff;
  border-color: var(--primary);
}
.section-chip.active .badge {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}
.empty-sidebar {
  text-align: center;
  color: var(--muted);
  padding: 0.75rem 0;
}

/* Items header/body */
.items-header .muted {
  margin: 0;
  color: var(--muted);
}
.items-body {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

/* Toolbar */
.items-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: center;
}
.search-field {
  flex: 1 1 240px;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 999px;
  padding: 0.55rem 1rem;
  transition: border 0.2s, box-shadow 0.2s;
}
.search-field:focus-within {
  border-color: rgba(99, 102, 241, 0.6);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
  background: #fff;
}
.search-field input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
}
.btn-clear {
  background: none;
  border: none;
  color: rgba(71, 85, 105, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 1rem;
}
.btn-clear:hover {
  color: rgba(15, 23, 42, 0.85);
}

.quick-filters {
  display: flex;
  gap: 0.5rem;
}

/* Category pills */
.category-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
.category-pill {
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  background: #f1f5f9;
  border: 1px solid rgba(148, 163, 184, 0.35);
  font-weight: 600;
  cursor: pointer;
  transition: 0.15s ease;
}
.category-pill.active {
  background: var(--primary);
  color: #fff;
  border-color: transparent;
}

/* Items grid */
.items-container {
  min-height: 240px;
}
.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px;
}
.item-card {
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s;
}
.item-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.08);
  border-color: rgba(79, 70, 229, 0.35);
}
.item-image-container {
  position: relative;
  aspect-ratio: 16 / 11;
  background: #f8fafc;
}
.item-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.stock-badge {
  position: absolute;
  left: 10px;
  bottom: 10px;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: 0.75rem;
  color: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}
.stock-badge.ok {
  background: var(--success);
}
.stock-badge.low {
  background: var(--warning);
}
.stock-badge.out {
  background: var(--danger);
}

.item-info {
  padding: 0.7rem 0.8rem 0.9rem;
}
.item-name {
  font-size: 0.98rem;
  line-height: 1.35;
  margin: 0 0 0.35rem 0;
  min-height: 2.4em;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item-meta {
  display: flex;
  gap: 0.5rem;
  color: var(--muted);
  font-size: 0.8rem;
}
.item-meta .ref {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

/* Skeletons */
.skeleton {
  pointer-events: none;
}
.skeleton .line {
  height: 10px;
  border-radius: 6px;
  background: #e5e7eb;
  margin: 8px 0 0;
}
.skeleton .line.short {
  width: 60%;
}
.shimmer {
  position: relative;
  overflow: hidden;
  background: #eceff3;
}
.shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  animation: shimmer 1.25s infinite;
  background: linear-gradient(
    90deg,
    rgba(236, 239, 243, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(236, 239, 243, 0) 100%
  );
}
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* Empty state */
.items-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  text-align: center;
  background: rgba(99, 102, 241, 0.05);
  border: 1px dashed rgba(99, 102, 241, 0.25);
  border-radius: 20px;
  padding: 2rem 1.25rem;
  color: #475569;
}
.items-empty-state h3 {
  margin: 0;
  font-size: 1.15rem;
  color: #1f2937;
}
.items-empty-state p {
  max-width: 380px;
  margin: 0;
  line-height: 1.5;
}
.items-empty-state .empty-icon {
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  background: rgba(99, 102, 241, 0.12);
  color: #4338ca;
  font-size: 1.6rem;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.9rem;
  border-radius: 10px;
  border: 1px solid transparent;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s;
}
.btn i {
  font-size: 1rem;
}
.btn-primary {
  background: var(--primary);
  color: #fff;
}
.btn-primary:hover {
  filter: brightness(0.95);
}
.btn-secondary {
  background: #0ea5e9;
  color: #fff;
}
.btn-secondary:hover {
  filter: brightness(0.95);
}
.btn-text {
  background: transparent;
  color: var(--primary);
  border-color: rgba(79, 70, 229, 0.25);
}
.btn-outline-light {
  background: #fff;
  color: #111827;
  border: 1px solid rgba(15, 23, 42, 0.12);
}
.btn-chip {
  background: var(--primary-weak);
  color: var(--primary);
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0.5rem 0.9rem;
  font-weight: 700;
}
.btn-chip.active {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 12px 25px rgba(79, 70, 229, 0.25);
}
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.spin {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);
  display: grid;
  place-items: center;
  padding: 1rem;
  z-index: 50;
}
.modal-content {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.25);
  animation: pop 0.18s ease-out;
}
@keyframes pop {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}
.modal-title {
  margin: 0;
  font-size: 1.1rem;
}
.modal-body {
  padding: 1rem 1.25rem 0;
}
.modal-footer {
  padding: 1rem 1.25rem 1.25rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}
.btn-close {
  background: #f1f5f9;
  border: 1px solid rgba(148, 163, 184, 0.35);
}
.selected-product {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.product-image-modal {
  width: 58px;
  height: 58px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.25);
}
.product-name-modal {
  margin: 0;
}

/* Quantity keypad */
.quantity-input-section {
  margin-top: 0.8rem;
}
.quantity-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  border: 1px dashed rgba(148, 163, 184, 0.5);
  padding: 0.7rem 1rem;
  border-radius: 12px;
  font-weight: 800;
}
.quantity-label {
  color: var(--muted);
}
.quantity-value {
  font-size: 1.25rem;
}
.modal-keyboard {
  margin-top: 0.8rem;
}
.keyboard-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.55rem;
}
.btn-key {
  border-radius: 12px;
  background: #111827;
  color: #fff;
  padding: 0.85rem 0;
  font-size: 1.05rem;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.btn-key:active {
  transform: translateY(1px);
}
.btn-key-clear {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}

/* Alerts */
.customer-warning {
  margin-top: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  padding: 0.6rem 0.8rem;
  border-radius: 10px;
}

/* Utilities */
.muted {
  color: var(--muted);
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Mobile */
@media (max-width: 650px) {
  .catalog-page {
    padding: 1.2rem 0.9rem 4rem;
    height: auto;
    gap: 1.15rem;
    background: #fff;
    overflow: visible;
  }
  .catalog-content {
    display: block;
  }
  .catalog-sidebar {
    display: none !important;
  }
  .panel {
    border-radius: 18px;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.07);
  }
  .panel-header {
    padding: 1.1rem;
  }
  .panel-header h2 {
    font-size: 1.2rem;
  }
  .category-pills {
    overflow-x: auto;
    gap: 0.6rem;
    padding-bottom: 0.3rem;
    scrollbar-width: none;
  }
  .category-pills::-webkit-scrollbar {
    display: none;
  }
  .category-pill {
    white-space: nowrap;
    padding: 0.5rem 0.85rem;
    font-size: 0.86rem;
  }
  .items-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .header-actions {
    width: 100%;
  }
  .header-actions .btn {
    flex: 1;
    justify-content: center;
    border-radius: 12px;
    padding: 0.65rem 0.75rem;
  }
}

/* SR only (for accessibility) */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
